import { Field, Form } from "formik";
import { Dropdown } from "primereact";
import { IMaskInput } from "react-imask";
import styled from "styled-components";
import { theme } from "../../styles/theme";

export const InputMaskStyled = styled.input`
  font-size: 1.6rem;
  padding: 5px 0;
  width: 100%;
  height: 40px;
  border-bottom-width: 1px;
`;

export const CountNumber = styled.span`
  font-size: 1.6rem;
  padding: 5px 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${theme.colors.blue100};
  color: ${theme.colors.darkBlue};
  margin-right: 10px;
`;

export const DownloadButton = styled.a`
  position: absolute;
  display: flex;
  justify-content: center;
  padding: 5px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 6px;
  cursor: pointer;
  transition: ease all 200ms;
  right: 10px;

  svg {
    margin: 0 !important;
  }

  &:hover {
    background-color: ${theme.colors.primary};

    svg path {
      fill: #fff;
    }
  }
`;

export const RadioStyled = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  margin-bottom: 15px;
`;

export const CheckboxStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-bottom: 15px;

  label {
    display: flex;
    flex-direction: column;
    font-size: 1rem;

    input {
      margin: 0;
    }
  }

  .error-field-yesno {
    bottom: -15px;
    margin-left: 0;
  }

  .checkbox-container {
    padding-left: 25px;
    width: 75% !important;
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
  }

  @media screen and (max-width: 479px) {
    .w-25 {
      width: 100% !important;
    }
  }
`;

export const ToogleStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-bottom: 15px;

  .error-field-toggle {
    bottom: -15px;
    margin-left: 0;
  }
`;

export const ToogleButtonStyled = styled.div`
  display: flex;
  width: 46px;
  height: 24px;
  position: relative;
  border-radius: 20px;
  border: 1px solid ${theme.colors.lightGray};
  background-color: ${theme.colors.primary};
  transition: ease all 300ms;

  &:before {
    content: "";
    width: 18px;
    height: 18px;
    position: absolute;
    background-color: #fff;
    border-radius: 10px;
    margin: 2px;
    left: 0;
  }
`;

export const FieldSeclectStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 10px;
`;

export const FileContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100% !important;

  .file-content {
    width: 100% !important;
    display: flex !important;
    flex-direction: row !important;

    label {
      width: 100% !important;
    }
  }

  .error-field-file {
    bottom: 5px;
  }
`;

export const FieldStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  input {
    border-radius: ${theme.border.radius};
    color: ${theme.colors.white};
    background-color: transparent;
  }

  .react-tags-wrapper {
    width: 75% !important;
  }

  .ReactTags__selected {
    padding-left: 25px;
    display: flex;
    gap: 10px;
  }

  .tag-wrapper {
    display: flex;
    gap: 5px;
  }
`;

export const FileStyled = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  border: 1px solid ${theme.colors.lightGray};
  width: 40%;
  padding: 7px;
  border-radius: 10px;
  margin-top: 5px;
  height: 45px;
  cursor: pointer;

  svg {
    margin-right: 10px;
    margin-left: 10px;
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  p {
    margin: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
`;

export const RadioBox = styled(Field)`
  height: 15px;
  width: 15px;
  accent-color: ${theme.colors.primary};
  margin: 0 10px 0 5px;
`;

type ToggleProps = {
  disabled: boolean;
};

export const CheckboxToggle = styled(Field)<ToggleProps>`
  height: 15px;
  width: 15px;
  accent-color: ${theme.colors.blue400};
  margin: 0 15px 0 5px;

  &:checked + div .toggle {
    background-color: ${(props) =>
      props.disabled ? theme.colors.lightGray : theme.colors.primary};

    &:before {
      content: "";
      width: 18px;
      height: 18px;
      position: absolute;
      background-color: #fff;
      border-radius: 10px;
      margin: 2px;
      right: 0;
    }
  }
`;

export const Checkbox = styled(Field)`
  height: 15px;
  width: 15px;
  accent-color: green;
  margin: 0 7px 0 5px;
`;

type ImaskProps = {
  disabled: boolean;
};

export const InpuImasktStyled = styled(IMaskInput)<ImaskProps>`
  padding: 10px 15px 10px 25px;
  border: 1px solid ${theme.colors.lightGray};
  background-color: transparent;
  border-radius: ${theme.border.radius};
  height: 45px;
  margin-bottom: 15px;

  font-family: ${theme.font.poppins};
  color: ${theme.colors.white};

  ${(props) =>
    props.disabled &&
    `
    border: 1px solid #dcdcdc;
    background-color: transparent;
    color: #ababab;

    input:disabled {
      border: none;
    }
  `}
`;

export const DropdownStyled = styled(Dropdown)<ImaskProps>`
  font-family: ${theme.font.poppins};
  background-color: ${theme.colors.darkBlue};
  border: 1px solid ${theme.colors.lightGray};
  border-radius: ${theme.border.radius};
  color: ${theme.colors.white} !important;
  height: 45px;
  margin-bottom: 15px;

  ${(props) =>
    props.disabled &&
    `
    border: 1px solid #dcdcdc;
    background-color: ${theme.colors.blue900};
    color: #ababab;

    input:disabled {
      border: none;
    }
  `}

  @media screen and (max-width: 479px) {
    width: 100% !important;
  }
`;

export const TextAreaStyled = styled.textarea`
  font-family: ${theme.font.poppins};
  padding: 10px 15px 10px 25px;
  border: 1px solid ${theme.colors.lightGray};
  border-radius: ${theme.border.radius};
  color: ${theme.colors.white};
  margin-bottom: 15px;
  background-color: transparent;

  &:disabled {
    border: 1px solid #dcdcdc;
    background-color: transparent;
    color: #ababab;
  }
`;

export const InputStyled = styled(Field)`
  font-family: ${theme.font.poppins};
  padding: 10px 15px 10px 25px;
  border: 1px solid ${theme.colors.lightGray};
  border-radius: ${theme.border.radius};
  color: ${theme.colors.white};
  background-color: transparent;
  height: 45px;
  margin-bottom: 15px;
  width: 75% !important;

  &:disabled {
    border: 1px solid #dcdcdc;
    background-color: transparent;
    color: #ababab;
  }
`;

export const InputNativeStyled = styled.input`
  font-family: ${theme.font.poppins};
  padding: 10px 15px 10px 25px;
  border: 1px solid ${theme.colors.lightGray};
  border-radius: ${theme.border.radius};
  color: ${theme.colors.white};
  height: 45px;
  margin-bottom: 15px;
  background-color: transparent;

  &:disabled {
    border: 1px solid #dcdcdc;
    background-color: transparent;
    color: #ababab;
  }
`;

export const LabelGroupStyled = styled.label`
  width: auto;
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.semiBold};
  color: ${theme.colors.white};
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  margin: 0 0 20px 0;
  padding: 0;

  @media screen and (max-width: 479px) {
    font-size: 1.3rem;
    margin-top: 1rem !important;
    padding-left: 1rem;

    span {
      min-width: 17%;
    }
  }
`;

export const ErrorStyled = styled.span`
  color: #fe5005;
  font-size: 0.7rem;
  position: absolute;
  margin: 5px 0 0 17px;
  bottom: 0;
`;

export const ErrorStyledRecoveryPassword = styled(ErrorStyled)`
  margin-bottom: 15px;
`;

export const ViewPass = styled.span`
  position: absolute;
  right: 25px;
  top: 7px;
  font-size: 1.3rem;
  z-index: 9999;

  @media screen and (max-width: 479px) {
    right: 5%;
  }
`;

type NumberProp = {
  disabled: boolean;
};

export const NumberInputContainer = styled.div<NumberProp>`
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid ${theme.colors.lightGray};
  border-radius: 12px;
  color: ${theme.colors.white};
  margin-bottom: 25px;
  justify-content: space-between;

  input {
    width: 45%;
    border: none;
    padding: 0;
    text-align: center;
    margin-bottom: 0 !important;

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  ${(props) =>
    props.disabled &&
    `
    border: 1px solid #dcdcdc;
    background-color: transparent;
    color: #ababab;

    input:disabled {
      border: none;
    }
  `}
`;

export const ButtonInput = styled.button`
  display: flex;
  background-color: transparent;
  justify-content: center;
  align-items: center;
  width: 25%;
  color: ${theme.colors.white};
`;

export const ContentFields = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 479px) {
    margin: 0;
    padding: 10px !important;

    > div:has(button) {
      width: 100% !important;
      justify-content: center;
      padding: unset !important;
      margin-top: unset !important;
    }

    button {
      width: 100% !important;
      padding: 10px 18px;
      font-size: 12px;
    }
  }
`;

export const FormikStyled = styled(Form)`
  width: 100%;
  background-color: transparent !important;

  ::-webkit-scrollbar {
    width: 16px !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #0c7488 !important;
    border-radius: 20px !important;
  }

  &.internal-form {
    input[type="text"],
    input[type="date"],
    input[type="number"],
    input[type="password"] {
      border-radius: 12px;
      max-height: 43px;
      padding-left: 15px;
      font-size: 0.8rem;
      margin-bottom: 25px;
    }

    button[type="submit"] {
      width: auto;
      padding: 15px 60px;
      font-size: 0.8rem;
      font-weight: 400;
      margin-top: 50px;
    }

    .select-input {
      border-radius: 12px;
      max-height: 43px;
      padding-left: 15px;
      font-size: 0.8rem;
    }

    .container-form {
      padding: 0;

      .checkbox {
        flex-direction: column-reverse;
        align-items: baseline;

        label {
          margin-bottom: 10px;
        }
      }
    }

    .error-field {
      position: absolute;
      bottom: 10px;
    }
  }

  &.editMode {
    button[type="submit"] {
      display: none;
    }
  }

  @media screen and (max-width: 479px) {
    width: 100%;

    .row-container {
      padding: unset !important;
    }

    .button-box {
      margin: 0 auto !important;
      width: 100% !important;
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      padding: 0 !important;
    }

    .button-box button {
      width: 100% !important;
      margin: unset !important;
    }
  }
`;

export const LabelRadioStyled = styled.label`
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const LabelStyled = styled.label`
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.white};
  font-size: 0.7rem;
  margin-bottom: 5px;
  width: 25% !important;

  &.m-0 {
    margin: 0;
  }

  &.checkbox-tooltip {
    width: fit-content;
  }

  &.select-tooltip div {
    display: inline;
  }

  @media screen and (max-width: 479px) {
    font-size: 1rem;
  }

  cursor: pointer;
`;

export const ContainerForm = styled.div`
  width: 100%;
  border-bottom: 2px solid ${theme.colors.blue900};
  margin-bottom: 45px;
  padding-bottom: 30px;

  @media screen and (max-width: 479px) {
    width: 100%;
    padding: 0;

    .col-2,
    .col-4,
    .col-6,
    .col-8 {
      width: 100% !important;
    }
  }
`;
